module.exports = __webpack_public_path__ + "static/media/BookIconWhite.fb954731.svg";